"use client"

import { useQueryClient } from "@tanstack/react-query"
import { usePostComments } from "openapi/api/endpoints"
import type { PostCommentsBody } from "openapi/api/model"
import { toast } from "sonner"

type CreateEventNoteArgs = {
  linkType: "job" | "candidate"
  jobId?: string
  candidateId?: string
  notes?: string
}

export function useEventNoteCreation() {
  const { mutateAsync: postComment } = usePostComments()
  const queryClient = useQueryClient()

  const createEventNote = async ({ linkType, jobId, candidateId, notes }: CreateEventNoteArgs) => {
    const body = notes?.trim()
    if (!body) return

    let payload: PostCommentsBody | null = null

    if (linkType === "candidate") {
      if (!jobId || !candidateId) return
      payload = {
        label: "note",
        body,
        entity_type: "job_candidate",
        job_id: jobId,
        candidate_id: candidateId,
      }
    } else {
      if (!jobId) return
      payload = {
        label: "note",
        body,
        entity_type: "jobs",
        entity_id: jobId,
      }
    }

    try {
      await postComment({ data: payload })
      await queryClient.invalidateQueries({ queryKey: ["/comments"], exact: false })
    } catch (error) {
      toast.error("Event created, but note creation failed", {
        description: `${error}`,
        className: "text-white",
        descriptionClassName: "text-white",
        action: { label: "Dismiss", onClick: () => {} },
        style: { background: "#dc2626" },
      })
    }
  }

  return { createEventNote }
}
